import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import './styles.less'
import TargetGroupWidget from '../../widgets/basicProjectInfo/targetSetting/TargetGroupWidget'
import ThePointWidget from '../../widgets/basicProjectInfo/targetSetting/ThePointWidget'
import ChkAreaSettingWidget from '../../widgets/basicProjectInfo/targetSetting/ChkAreaSettingWidget'
import AdministrativeAreaWidget from '../../widgets/basicProjectInfo/targetSetting/AdministrativeAreaWidget'
import BtnEditAll from '../../components/buttons/btnEditAll/BtnEditAll'
import { getAllTargetData } from '../../redux/actions/targetSetting'
import { startLoading, doneLoading } from '../../utils/loading'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../utils/widget'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import TagetDep6Widget from '../../widgets/basicProjectInfo/targetSetting/TagetDep6Widget'
import pathname from '../../constants/pathname'
import { ERR_MSG_404_PROJECT_ID } from '../../constants/msgText'
import ViewPreviousVersionButon from '../../components/buttons/viewPreviousVersionButon/ViewPreviousVersionButon'
import { Panel } from 'rsuite'

export default function TargetSettingView(props) {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [schemas, setSchemas] = useState()
  const [error, setError] = useState()
  const [showEditAll, setShowEditAll] = useState()
  const [schemaPrevious, setSchemaPrevious] = useState()
  const [isViewPrevious, setIsViewPrevious] = useState(false)

  const projectId = sessionStorage.getItem('projectId')
  const buttonRoute = {
    pathNameBackward: `${pathname.proposal.backgroundAndImportant}`,
    pathNameForward: `${pathname.proposal.goal}`,
  }

  useEffect(() => {
    if (projectId) {
      handleGetSchema(projectId)
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getAllTargetData(proposalId)
      setSchemas(_schema)
      setIsEditWidget({
        targetGroup:
          _schema?.forms?.targetGroup?.criteriaList?.optionSelected?.length > 0 ? false : true,
        targetIssue:
          _schema?.forms?.targetIssue?.issues?.optionSelected?.length > 0 ||
            _schema?.forms?.targetIssue?.issues?.inputOther?.value
            ? false
            : true,
        targetSetting:
          _schema?.forms?.targetSetting?.areaSetting?.optionSelected?.length > 0 ||
            _schema?.forms?.targetSetting?.areaSetting?.inputOther?.value ||
            _schema?.forms?.targetSetting?.areaSetting?.disabledAllCheckbox?.value
            ? false
            : true,
        targetArea: _schema?.forms?.targetArea?.areaList?.value?.length > 0 ? false : true,
        tagetDep6Main: _schema?.forms?.tagetDep6Main?.taget?.values?.length > 0 ? false : true,
        tagetDep6Sub: _schema?.forms?.tagetDep6Sub?.taget?.values?.length > 0 ? false : true,
      })
      let targetGroup = _schema?.forms?.targetGroup ? !_schema.forms.targetGroup.disabled : true
      let targetIssue = _schema?.forms?.targetIssue ? !_schema.forms.targetIssue.disabled : true
      let targetSetting = _schema?.forms?.targetSetting
        ? !_schema.forms.targetSetting.disabled
        : true
      let targetArea = _schema?.forms?.targetArea ? !_schema.forms.targetArea.disabled : true
      let tagetDep6Main = _schema?.forms?.tagetDep6Main
        ? !_schema.forms.tagetDep6Main.disabled
        : true
      let tagetDep6Sub = _schema?.forms?.tagetDep6Sub ? !_schema.forms.tagetDep6Sub.disabled : true
      setShowEditAll(
        targetGroup && targetIssue && targetSetting && targetArea && tagetDep6Main && tagetDep6Sub
      )
    } catch (e) { }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetSchemaPrevious = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      if (isViewPrevious) {
        setIsViewPrevious(false)
        doneLoading()
        setIsLoading(false)
        return
      }
      if (schemaPrevious) {
        setIsViewPrevious(true)
        doneLoading()
        setIsLoading(false)
        return
      }
      const _schema = await getAllTargetData(proposalId)
      setSchemaPrevious(_schema)
      setIsViewPrevious(true)
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  // ก้อนที่ 1: ข้อมูลปัจจุบัน
  const renderCurrentVersion = (
    <div className="top">


      {schemas?.forms?.targetGroup && (
        <>
          <TargetGroupWidget
            showCommandButton={!schemas.forms.targetGroup.disabled}
            schema={schemas.forms.targetGroup}
            isEdit={isEditWidget.targetGroup}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('targetGroup', _isEdit, setIsEditWidget)
            }
          />
          <br />
        </>
      )}

      {schemas?.forms?.targetIssue && (
        <>
          <ThePointWidget
            showCommandButton={!schemas.forms.targetIssue.disabled}
            schema={schemas.forms.targetIssue}
            isEdit={isEditWidget.targetIssue}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('targetIssue', _isEdit, setIsEditWidget)
            }
          />
          <br />
        </>
      )}

      {schemas?.forms?.targetSetting && (
        <>
          <ChkAreaSettingWidget
            showCommandButton={!schemas.forms.targetSetting.disabled}
            schema={schemas.forms.targetSetting}
            isEdit={isEditWidget.targetSetting}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('targetSetting', _isEdit, setIsEditWidget)
            }
          />
          <br />
        </>
      )}

      {schemas?.forms?.targetArea && (
        <>
          <AdministrativeAreaWidget
            showCommandButton={!schemas.forms.targetArea.disabled}
            schema={schemas.forms.targetArea}
            isEdit={isEditWidget.targetArea}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('targetArea', _isEdit, setIsEditWidget)
            }
          />
          <br />
        </>
      )}

      {schemas?.forms?.tagetDep6Main && (
        <>
          <TagetDep6Widget
            showCommandButton={!schemas.forms.tagetDep6Main.disabled}
            schema={schemas.forms.tagetDep6Main}
            isEdit={isEditWidget.tagetDep6Main}
            type="main"
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('tagetDep6Main', _isEdit, setIsEditWidget)
            }
          />
          <br />
        </>
      )}

      {schemas?.forms?.tagetDep6Sub && (
        <>
          <TagetDep6Widget
            showCommandButton={!schemas.forms.tagetDep6Sub.disabled}
            schema={schemas.forms.tagetDep6Sub}
            isEdit={isEditWidget.tagetDep6Sub}
            type="sub"
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('tagetDep6Sub', _isEdit, setIsEditWidget)
            }
          />
          <br />
        </>
      )}
    </div>
  )

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schemas.header} subHeader={schemas.subHeader} />
        <ViewPreviousVersionButon 
          handleGetSchemaPrevious={handleGetSchemaPrevious} 
          isViewPrevious={isViewPrevious}
          masterSubjectId={'1-1006,1-1007,1-1008,1-1009,1-1010,5-5004'}
        />
        {showEditAll && (
        <BtnEditAll
          onClickEditAll={getIsEditAll(isEditWidget)}
          routing={buttonRoute}
          setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
          editWidget={isEditWidget}
          forms={schemas?.forms}
        />
      )}
        <div className="wrapper">
          {/* ส่วนแสดงข้อมูลปัจจุบัน */}
          <div style={!isViewPrevious ? { width: '100%' } : {}}>
            {isViewPrevious ? (
              <Panel
                //classPrefix="view-version-panel"
                collapsible
                defaultExpanded
                shaded
                bordered
                header={'version ปัจจุบัน'}
                style={{ maxHeight: '550px', overflowY: 'auto', width: '100%' }}
              >
                {renderCurrentVersion}
              </Panel>
            ) : (
              renderCurrentVersion
            )}
          </div>

          {/* ส่วนแสดงข้อมูลก่อนหน้า */}
          {isViewPrevious && schemaPrevious && (
            <>
              <div className="line" />
              <div>
                <Panel 
                  collapsible 
                  defaultExpanded 
                  shaded 
                  bordered 
                  header={'version ก่อนหน้า'}
                  style={{ maxHeight: '550px', overflowY: 'auto', width: '100%', backgroundColor: '#e4e4ed' }}
                >
                  <div className="bottom">
                    {schemaPrevious?.forms?.targetGroup && (
                      <>
                        <TargetGroupWidget
                          showCommandButton={false}
                          schema={schemaPrevious.forms.targetGroup}
                          isEdit={false}
                        />
                        <br />
                      </>
                    )}

                    {schemaPrevious?.forms?.targetIssue && (
                      <>
                        <ThePointWidget
                          showCommandButton={false}
                          schema={schemaPrevious.forms.targetIssue}
                          isEdit={false}
                        />
                        <br />
                      </>
                    )}

                    {schemaPrevious?.forms?.targetSetting && (
                      <>
                        <ChkAreaSettingWidget
                          showCommandButton={false}
                          schema={schemaPrevious.forms.targetSetting}
                          isEdit={false}
                        />
                        <br />
                      </>
                    )}

                    {schemaPrevious?.forms?.targetArea && (
                      <>
                        <AdministrativeAreaWidget
                          showCommandButton={false}
                          schema={schemaPrevious.forms.targetArea}
                          isEdit={false}
                        />
                        <br />
                      </>
                    )}

                    {schemaPrevious?.forms?.tagetDep6Main && (
                      <>
                        <TagetDep6Widget
                          showCommandButton={false}
                          schema={schemaPrevious.forms.tagetDep6Main}
                          isEdit={false}
                          type="main"
                        />
                        <br />
                      </>
                    )}

                    {schemaPrevious?.forms?.tagetDep6Sub && (
                      <>
                        <TagetDep6Widget
                          showCommandButton={false}
                          schema={schemaPrevious.forms.tagetDep6Sub}
                          isEdit={false}
                          type="sub"
                        />
                        <br />
                      </>
                    )}
                  </div>
                </Panel>
              </div>
              <br />
              <br />
            </>
          )}
        </div>
      </SidebarProposal>
    </>
  )
}